import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function CategoriesPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("sectionCategories")}
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                Browse all product categories on the AllChinaBuy spreadsheet. Click any category to explore products on the main website.
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group block rounded-2xl overflow-hidden border border-background-200/70 bg-background-100 hover:border-primary-300 hover:shadow-md transition-all"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={cat.image}
                      alt={t(cat.nameKey)}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <p className="font-semibold text-sm text-foreground-800 group-hover:text-primary-700 transition-colors">
                      {t(cat.nameKey)}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}